import {
  CHANGE_DIRECTION,
  CHANGE_NAVIGATION_STYLE,
  DARK_THEME,
  DRAWER_TYPE,
  HORIZONTAL_MENU_POSITION,
  SWITCH_LANGUAGE,
  THEME_COLOR
} from '../../constants/ActionTypes';

export function setDrawerType(drawerType) {
  return {type: DRAWER_TYPE, drawerType};
}


export function setThemeColor(color) {
  return {type: THEME_COLOR, color};
}

export function setDarkTheme() {
  return {type: DARK_THEME};
}

export function changeDirection() {
  return {type: CHANGE_DIRECTION};
}

export function changeNavigationStyle(layoutType) {
  return {
    type: CHANGE_NAVIGATION_STYLE,
    payload: layoutType
  };
}

export function setHorizontalMenuPosition(navigationPosition) {
  return {
    type: HORIZONTAL_MENU_POSITION,
    payload: navigationPosition
  };
}

export function switchLanguage(locale) {
  return {
    type: SWITCH_LANGUAGE,
    payload: locale
  };
}
